const $ = require('jquery');


const desktopCarouselSelector = '.desktop-carousel';
const tabletCarouselSelector = '.tablet-carousel';
const mobileCarouselSelector = '.mobile-carousel';
const carouselInnerSelector = '.carousel-inner';
const dynamicContentItem2Selector = '.dynamic-content2-item';
const desktopCarouselDuration = 'data-desktop-carouselduration';
const tabletCarouselDuration = 'data-tablet-carouselduration';
const mobileCarouselDuration = 'data-mobile-carouselduration';
const idAttribute = 'id';
const itemClassName = 'item';
const activeClassName = 'active';
const slideClassName = 'slide';
const carouselClassName = 'carousel';
const sfHomeCarouselSelector = '.categoryList-Carousel';
const sfImageSelector = 'img.img-responsive';
const smalFormatlHomeCardSelector = '.inspirationCard.has-homepage-small-image';
const smalFormatlHomeCardTextSelector = '.inspirationCard.has-homepage-small-image .inspirationCard-textWrapper.is-showing-image';


function DynamicContentCarouselService() {
    this.smallFormatHomeCarouselHeight = 0;
    this.indicatorColor = null;
}

DynamicContentCarouselService.prototype.populateNavArrows = function (elm, id) {
    let buttons = `<button class="carousel-control left" href="#${id}" role="button" data-slide="prev"><i class="iconww-ArrowLeft nav-icon"></i><span class="sr-only">Previous</span></button>`;
    buttons += `<button class="carousel-control right" href="#${id}" role="button" data-slide="next"><i class="iconww-ArrowRight nav-icon"></i><span class="sr-only">Next</span></button>`;

    elm.find(carouselInnerSelector).after(buttons);
};

DynamicContentCarouselService.prototype.populateIndicator = function (elm, id) {
    const itemCount = elm.find(dynamicContentItem2Selector).length;
    let indicators = '<ol class="carousel-indicators">';
    for (let i = 0; i < itemCount; i++) {
        if (i === 0) {
            indicators += `<li data-target="#${id}" data-slide-to="${i}" class="active"></li>`;
        } else {
            indicators += `<li data-target="#${id}" data-slide-to="${i}"></li>`;
        }
    }
    indicators += '</ol>';

    elm.find(carouselInnerSelector).before(indicators);
};

DynamicContentCarouselService.prototype.initializeCarousel = function (elm, id, duration) {
    if (elm.find(carouselInnerSelector).length !== 0) {
        return;
    }
    elm.addClass(carouselClassName).addClass(slideClassName);
    elm.find(dynamicContentItem2Selector).addClass(itemClassName).wrapAll('<div class=\'carousel-inner\' />');
    elm.find(dynamicContentItem2Selector).eq(0).addClass(activeClassName);
    this.populateIndicator(elm, id);
    this.populateNavArrows(elm, id);
    const option = {
        pause: 'hover',
        swipe: 30,
    };
    if (duration !== undefined && duration > 0) {
        duration = duration >= 1000 ? duration : duration * 1000;
        option.interval = duration;
    }
    elm.carousel(option);
};

function updateCardImageHeight(carousel, height) {
    const cardHeight = height - 20;
    carousel.find(smalFormatlHomeCardSelector).css('height', cardHeight);
    carousel.find(smalFormatlHomeCardTextSelector).css('width', `calc(100% - ${cardHeight}px)`);
}

DynamicContentCarouselService.prototype.init = function () {
    const dynamicContentWindowWidthCal = $(window).width();
    const isScrollBarCal = $(document).height() > $(window).height();
    const transitionWidthCal = isScrollBarCal ? 950 : 960;
    if (dynamicContentWindowWidthCal > transitionWidthCal) {
        this.initializeCarouselBySelector(desktopCarouselSelector);
    } else if (dynamicContentWindowWidthCal > 767) {
        this.initializeCarouselBySelector(tabletCarouselSelector);
    } else {
        this.initializeCarouselBySelector(mobileCarouselSelector);
    }
};


DynamicContentCarouselService.prototype.initializeCarouselBySelector = function (selector) {
    $(selector).each((i, v) => {
        if ($(v).find(carouselInnerSelector).length === 0) {
            const id = $(v).attr(idAttribute);
            const durationAttr = selector === desktopCarouselSelector ? desktopCarouselDuration : selector === tabletCarouselSelector ? tabletCarouselDuration : mobileCarouselDuration;
            const duration = $(v).attr(durationAttr);
            this.initializeCarousel($(v), id, duration);
        }
    });
};

DynamicContentCarouselService.prototype.getSmallFormatHomeCarouselHeight = function () {
    let height = 0;
    const sfHomeCarousel = $(sfHomeCarouselSelector).find(mobileCarouselSelector);
    if (sfHomeCarousel.length) {
        const images = sfHomeCarousel.find(sfImageSelector);
        const parentItem = $(images[0]).parents(dynamicContentItem2Selector);
        const visible = parentItem.hasClass(activeClassName);
        if (!visible) {
            parentItem.addClass(activeClassName);
        }
        height = $(images[0]).height();
        if (!visible) {
            parentItem.removeClass(activeClassName);
        }
        updateCardImageHeight(sfHomeCarousel, height);
    }
    return height;
};

module.exports = DynamicContentCarouselService;



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/dynamic-content-carousel.service.js